import Controller from "./preLockedMap.controller";
import template from "./preLockedMap.html";

const preLockedMap = {
  template,
  controller: Controller,
  bindings: {
    ride: "<",
  },
};

export default preLockedMap;



// WEBPACK FOOTER //
// ./src/components/preLockedMap/preLockedMap.component.js